import gql from 'graphql-tag';

export const CtgLoyaltyAssignPersonalizedOffer = gql`
  mutation ctgLoyaltyCreatePersonalizedOffer(
    $loyaltyId: String!
    $offerConfigId: String!
    $cognitoId: String!
    $reason: String!
    $orderId: String
    $comments: String
  ) {
    ctgLoyaltyCreatePersonalizedOffer(
      loyaltyId: $loyaltyId
      offerConfigId: $offerConfigId
      cognitoId: $cognitoId
      reason: $reason
      orderId: $orderId
      comments: $comments
    ) {
      configId
      id
      loyaltyId
    }
  }
`;
